import script from "./ListingBlockHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListingBlockHeader.vue?vue&type=script&setup=true&lang=ts"

import "./ListingBlockHeader.vue?vue&type=style&index=0&id=12a45595&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12a45595"]])

export default __exports__